import { Check, ShieldCheck, Zap } from "lucide-react";
import { licenseBenefits, whatsappUrl } from "../mock";

export default function License() {
  return (
    <section id="licenca" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-100 text-emerald-700 text-xs font-semibold mb-4">
            Licença iGreen Connect
          </div>
          <h2 className="text-slate-900 text-3xl md:text-5xl font-extrabold leading-tight">
            Tudo que Você Precisa para <br className="hidden md:block" />
            <span className="green-gradient-text">Começar a Ganhar</span>
          </h2>
          <p className="mt-5 text-slate-600 max-w-2xl mx-auto">
            A licença iGreen Connect é o seu passaporte para uma nova carreira no setor de energia. Com ela, você tem acesso a todas as ferramentas e suporte necessários para ter sucesso.
          </p>
        </div>

        <div className="mt-12 grid lg:grid-cols-2 gap-8 items-start">
          <div className="space-y-3">
            {licenseBenefits.map((b) => (
              <div key={b} className="flex items-start gap-3 p-4 rounded-xl bg-slate-50 border border-slate-200 hover:border-emerald-400 transition-colors">
                <div className="w-6 h-6 rounded-full bg-emerald-500 grid place-items-center flex-shrink-0 mt-0.5">
                  <Check className="w-3.5 h-3.5 text-white" />
                </div>
                <p className="text-slate-700 text-sm md:text-base">{b}</p>
              </div>
            ))}
          </div>

          <div className="rounded-3xl border-2 border-emerald-500/40 bg-gradient-to-b from-emerald-50 to-white p-8 shadow-xl relative overflow-hidden">
            <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-emerald-200/50 blur-3xl" />
            <div className="relative">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-100 text-amber-700 text-[11px] font-bold uppercase tracking-wide">
                Investimento Único
              </div>
              <h3 className="mt-4 text-slate-900 font-bold text-2xl">Licença anual</h3>
              <div className="mt-6">
                <div className="text-slate-500 text-sm">12x de</div>
                <div className="text-5xl md:text-6xl font-extrabold text-emerald-600">R$197,41</div>
                <div className="text-slate-700 mt-2">
                  ou <b className="text-slate-900">R$1.997</b> à vista
                </div>
                <div className="text-slate-500 text-sm mt-1">Renovação: R$1.197/ano</div>
              </div>

              <ul className="mt-6 space-y-2 text-sm text-slate-700">
                <li className="flex items-center gap-2"><Zap className="w-4 h-4 text-emerald-500" /> Acesso imediato ao sistema</li>
                <li className="flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-emerald-500" /> Suporte completo do seu executivo</li>
              </ul>

              <a href={whatsappUrl} target="_blank" rel="noreferrer" className="btn-gold inline-flex items-center justify-center w-full gap-2 px-6 py-4 rounded-xl text-base mt-6">
                Chamar no WhatsApp
              </a>
              <p className="text-slate-500 text-xs text-center mt-3">Pagamento seguro • Acesso imediato</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
